import React, { useEffect, useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TiWarningOutline } from 'react-icons/ti';
import { useNavigate, useParams } from 'react-router-dom';
import { IParams } from '../../../../../model/shared/IParams';
import EmptyState from '../../../../../shared/components/placeholder/EmptyState';
import { useSearchQuery } from '../../../../../shared/hooks/useSearchQuery';
import { ErrorToast, SuccessToast } from '../../../../../utils/toasters';
import BookingOverviewCard from '../offer/BookingOverviewCard';
import { IOfferOverviewCart } from '../offer/dto/IOfferOverviewCart';
import { BookingService } from '../service';
import { CheckoutCard } from './CheckoutCard';
import { IOffersCheckout } from '../../../../../model/offer/IOffersCheckout';
import { BackButton } from '../../../../../shared/components/button/BackButton';

export function CheckoutBook() {
    const [checkoutOffers, setCheckoutOffers] = useState<IOffersCheckout>();
    const [overviewCart, setOverviewCart] = useState<IOfferOverviewCart>();
    const [updateOverviewCart, setUpdateOverviewCart] = useState(false);
    const [updateOffers, setUpdateOffers] = useState(false);
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();
    const hasSent = useSearchQuery('hasSent') === 'true';
    const navigate = useNavigate();

    useEffect(() => {
        BookingService.getOffersCheckout(id ?? '')
            .then(response => {
                setCheckoutOffers(response);
            })
            .catch(err => ErrorToast(err));
    }, [updateOffers]);

    useEffect(() => {
        BookingService.getOfferCartInfo(id).then(response => {
            setOverviewCart(response);
        });
    }, [updateOverviewCart]);

    function deselectOffer(offerId: number) {
        BookingService.selectOffer(offerId)
            .then(response => {
                if (response) {
                    setUpdateOffers(!updateOffers);
                    SuccessToast(t('general.toasts.successfullyRemovedOffer'));
                    setUpdateOverviewCart(!updateOverviewCart);
                }
            })
            .catch(error => ErrorToast(error));
    }

    function acceptOffer(offerId: number) {
        BookingService.acceptOffer(offerId)
            .then(response => {
                SuccessToast(t('general.toasts.successfullyAccepeted'));
                setUpdateOffers(!updateOffers);
                setOverviewCart(response);
            })
            .catch(error => ErrorToast(error));
    }

    // function declineOffer(offerId: number) {
    //     BookingService.declineOffer(offerId)
    //         .then((response) => {
    //             SuccessToast(t('general.toasts.successDeclined'));
    //             setUpdateOffers(!updateOffers);
    //         }).catch(error => ErrorToast(error));
    // }

    const bookSelectedOffer = () => {
        BookingService.bookSelectedOffer(id)
            .then(response => {
                SuccessToast(t('general.toasts.bookedSelectedOffer'));
                setCheckoutOffers(response);
                setUpdateOverviewCart(!updateOverviewCart);
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <Row className="mb-5 mb-md-0 pb-5 pb-md-0">
            <Col xl={9}>
                <Row>
                    <BackButton />
                    {(checkoutOffers?.selectedOffersCount ?? 0) > 0 && (
                        <div className="col-12 pl-0 mt-3">
                            <h4 className="w-100 d-flex justify-content-between">
                                {t('brand.campaign.book.offer.selected_offer')}({checkoutOffers?.selectedOffersCount})
                            </h4>
                        </div>
                    )}

                    <CheckoutCard
                        deselectOffer={deselectOffer}
                        offers={checkoutOffers?.selectedOffers}
                        bookingStatus="selected"
                        acceptOffer={acceptOffer}
                        declineOffer={deselectOffer}
                    />

                    {hasSent && (
                        <div className="col-12 pl-0 mt-3">
                            <Alert variant="warning" className="box-shadow w-fit-content d-flex align-items-center">
                                <TiWarningOutline size={20} />
                                {t('brand.campaign.book.checkout.hasSentOffers')}
                                <a
                                    onClick={() =>
                                        navigate(`/brand/campaign/book/${id}`, { state: { isSentActive: true } })
                                    }
                                    className="ml-1 cursor-pointer"
                                >
                                    {t('brand.campaign.book.checkout.takeALook')}
                                </a>
                            </Alert>
                        </div>
                    )}
                    {(checkoutOffers?.bookedOffersCount ?? 0) > 0 && (
                        <div className="col-12 pl-0 mt-3">
                            <h4 className="w-100">
                                {t('brand.campaign.book.offer.booked_offers')}({checkoutOffers?.bookedOffersCount})
                            </h4>
                        </div>
                    )}
                    <CheckoutCard
                        deselectOffer={deselectOffer}
                        offers={checkoutOffers?.bookedOffers}
                        bookingStatus="booked"
                    />
                    {!checkoutOffers?.bookedOffers?.length && !checkoutOffers?.selectedOffers?.length && (
                        <div className="card mt-3">
                            <div className="card-body">
                                <EmptyState />
                            </div>
                        </div>
                    )}
                </Row>
            </Col>
            <Col xl={3}>
                <BookingOverviewCard
                    offers={checkoutOffers?.selectedOffers}
                    bookSelectedOffer={bookSelectedOffer}
                    overviewCartInfo={overviewCart}
                />
            </Col>
        </Row>
    );
}
